<template>
  <div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <div class="panel">
        <div class="panel-heading">
          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-8">
              <div class="contentWrap">
                <div class="contentbox">
                  <div class="box-detail text-center alertBox">
                    <h2 class="heading blue">{{ this.surveyName }}</h2>
                  </div>
                </div>
                <div class="contentbox">
                  <div
                    class="box-detail"
                    v-for="question in questions"
                    :key="question.questionID"
                  >
                    <p class="surveyQuestion">
                      <strong>{{ question.question }}</strong>
                    </p>
                    <div class="box-detail text-center alertBox"></div>
                    <div v-if="question.optionsList" style="margin-left: 25px">
                      <div v-for="option in question.optionsList" :key="option">
                        <div v-if="option === 'empty'">
                          <input
                            class=""
                            type="text"
                            name="answers"
                            style="
                              outline: 0;
                              border-width: 0 0 2px;
                              border-color: #000002;
                            "
                            disabled
                          />
                        </div>
                        <div v-else class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            :name="question.questionID"
                            :id="option"
                            disabled
                          />
                          <label
                            class="form-check-label"
                            :for="option"
                            style="margin-left: 5px"
                            >{{ option }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-md-5">
                      <b-button
                        style="float: right"
                        type="button"
                        @click="goBack"
                        >Back</b-button
                      >
                    </div>
                    <div class="col-md-2">
                      <input
                        id="AddSurveyAnswer"
                        class="btn btn-default btn-success mg-t-20"
                        value="Submit"
                        name="saveanswer"
                        type="submit"
                        disabled
                      />
                    </div>
                    <div class="col-md-1"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import API from "@/api";
export default {
  data() {
    return {
      survey: null,
      questions: [],
      surveyName: "",
    };
  },
  created() {
    this.getPreviewSurvey();
  },
  methods: {
    goBack() {
      this.$router.go(-1); // Navigate back one step in the browser history
    },
    getPreviewSurvey() {
      API.getPreviewSurvey(
        this.$route.params.surveyID,
        (data) => {
          this.questions = data.data.map((question) => {
            return {
              ...question,
              optionsList: question.options
                .split("&")
                .map((option) => option.trim()),
            };
          });
          console.log(" this.questions :", this.questions);
          this.surveyName = data.data[0].surveyName;
          console.log("this.questions:", this.questions);
          console.log(
            "this.$route.params.surveyID:",
            this.$route.params.surveyID
          );
        },
        (err) => {
          console.error(err);
        }
      );
    },
  },
};
</script>
  